export default "__VITE_ASSET__CQm3q94F__"